<div class="d-inline-flex">
  <ncp-button
    #addAutonomyButton
    [options]="btnAIOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.devices.wheelchair.src"
      width="18"
      height="18"
      alt="Add Autonomy/Invalidity"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="autonomy_form"
      name="autonomy_form"
      [formGroup]="form"
      #aiFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-text-area #invalidityTxt [(options)]="autonomyInvalidityOptions" />
    </form>
  </ncp-modal>
</div>
